// src/components/MetaTags.js
import React from 'react';
import { Helmet } from 'react-helmet-async';

const MetaTags = ({ 
  title, 
  description, 
  keywords, 
  imageUrl, 
  url, 
  canonical,
  schema 
}) => {
  const defaultTitle = "Acting Auditions in India | Bollywood Casting Calls | BookMyAudition";
  const defaultDescription = "Find the latest acting auditions in India and casting calls for films, web series, television, theatre and advertisements on BookMyAudition.";
  const defaultKeywords = "acting auditions in India, auditions near me, latest auditions in India, upcoming auditions in India, casting calls India, acting casting calls, auditions for actors, BookMyAudition, Bollywood auditions, web series auditions, TV auditions, theatre auditions, ad film auditions";
  const defaultImageUrl = "https://web.bookmyaudition.com/social_logo.jpg";
  const siteUrl = "https://web.bookmyaudition.com";

  const currentUrl = url || (typeof window !== 'undefined' ? window.location.href : siteUrl);
  const canonicalUrl = canonical || currentUrl;

  return (
    <Helmet>
      <meta charSet="utf-8" />
      <title>{title || defaultTitle}</title>
      <meta name="description" content={description || defaultDescription} />
      <meta name="keywords" content={keywords || defaultKeywords} />
      <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
      <meta name="googlebot" content="index, follow, snippet, archive" />
      <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1" />
      <meta name="theme-color" content="#b7343a" />
      <link rel="canonical" href={canonicalUrl} />

      {/* Open Graph tags */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={currentUrl} />
      <meta property="og:title" content={title || defaultTitle} />
      <meta property="og:description" content={description || defaultDescription} />
      <meta property="og:image" content={imageUrl || defaultImageUrl} />
      <meta property="og:site_name" content="BookMyAudition" />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:type" content="image/jpeg" />

      {/* Twitter Card tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={currentUrl} />
      <meta name="twitter:title" content={title || defaultTitle} />
      <meta name="twitter:description" content={description || defaultDescription} />
      <meta name="twitter:image" content={imageUrl || defaultImageUrl} />

      {/* JSON-LD Structured Data Schema */}
      {schema && (
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      )}
    </Helmet>
  );
};

export default MetaTags;